/*
 * This module reads the "data-deals" attribute of the document element which
 * indicates the number of active deals per currency.
 *
 * Link will be shown if enough deals are active.
 */
import { travelData } from "@escapio/portal/state/travelData";

const FLAG_THRESHOLD = 3;

const dealCurrencies =
	JSON.parse(document.documentElement.getAttribute("data-deals")) || {};

export function getDealsCount() {
	return dealCurrencies[travelData.currency] || 0;
}

export const hasEnoughDeals = () => getDealsCount() >= FLAG_THRESHOLD;
